import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import AuthLayout from '@/layout/auth-layout.vue'
import AppLayout from '@/layout/app-layout.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: "/:catchAll(.*)",
    redirect: { name: 'dashboard' },
  },
  {
    name: 'admin',
    path: '/pages',
    component: AppLayout,
    children: [
      {
        name: 'dashboard',
        path: 'dashboard',
        meta: {
          requiresAuth: true
        },
        component: () => import('@/pages/admin/dashboard/Dashboard.vue'),
      },
      {
        name: 'jointsessions',
        path: 'jointsessions',
        meta: {
          requiresAuth: true
        },
        component: () => import('@/pages/admin/sessions/JointSessions.vue'),
      },
      {
        name: 'sessions',
        path: 'sessions',
        meta: {
          requiresAuth: true
        },
        component: () => import('@/pages/admin/sessions/Sessions.vue'),
      },
      {
        name: 'jointgrid',
        path: 'jointsessions/grid',
        meta: {
          requiresAuth: true
        },
        component: () => import('@/pages/admin/sessions/JointGrid.vue'),
      },
      {
        name: 'grid',
        path: 'sessions/grid',
        meta: {
          requiresAuth: true
        },
        component: () => import('@/pages/admin/sessions/Grid.vue'),
      },
      {
        name: 'files',
        path: 'sessions/:id/files',
        meta: {
          requiresAuth: true
        },
        component: () => import('@/pages/admin/files/Files.vue'),
      },
      {
        name: 'file',
        path: 'sessions/:id/files/:fileId',
        meta: {
          requiresAuth: true
        },
        component: () => import('@/pages/admin/files/File.vue'),
      },
      {
        name: 'jointfiles',
        path: 'jointsessions/:id/files',
        meta: {
          requiresAuth: true
        },
        component: () => import('@/pages/admin/files/JointFiles.vue'),
      },
      {
        name: 'jointgroupedfiles',
        path: 'jointsessions/:id/grouped-files',
        meta: {
          requiresAuth: true
        },
        component: () => import('@/pages/admin/files/JointGroupedFiles.vue'),
      },
      {
        name: 'jointattachments',
        path: 'jointsessions/:id/attachments',
        meta: {
          requiresAuth: true
        },
        component: () => import('@/pages/admin/files/JointAttachments.vue'),
      },
      {
        name: 'attachments',
        path: 'sessions/:id/attachments',
        meta: {
          requiresAuth: true
        },
        component: () => import('@/pages/admin/files/Attachments.vue'),
      },
      {
        name: 'attachment',
        path: 'sessions/:id/attachments/:attachmentId',
        meta: {
          requiresAuth: true
        },
        component: () => import('@/pages/admin/files/Attachment.vue'),
      },
      {
        name: 'users',
        path: 'users',
        meta: {
          requiresAuth: true
        },
        component: () => import('@/pages/admin/users/Users.vue'),
      },
      {
        name: 'user',
        path: 'users/:id',
        meta: {
          requiresAuth: true
        },
        component: () => import('@/pages/admin/users/User.vue'),
      },
      {
        name: 'profile',
        path: 'profile',
        meta: {
          requiresAuth: true
        },
        component: () => import('@/pages/admin/profile/Profile.vue'),
      }
    ]
  },
  {
    path: '/auth',
    component: AuthLayout,
    children: [
      {
        name: 'login',
        path: 'login',
        component: () => import('@/pages/auth/login/Login.vue'),
      },
      {
        name: 'recover-password',
        path: 'recover-password',
        component: () => import('@/pages/auth/recover-password/RecoverPassword.vue'),
      },
      {
        path: '',
        redirect: { name: 'login' },
      },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  //  mode: process.env.VUE_APP_ROUTER_MODE_HISTORY === 'true' ? 'history' : 'hash',
  routes
})

export default router
